import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CommonTermsCard } from '../../../components';
import backgroundImg from '../../../assets/images/svgs/onboard_bg.svg'
import lifegraphLogo from '../../../assets/images/onboardPage/lifegraph_logo.png'
import TranslationMessage from './transMessage';

const styles = {
    subContainer: {
        display: "flex",
        alignItems: 'center',
        justifyContent: "center",
        mb: "5rem"
    },
    bottomContainer: {
        mr: "1.1rem",
        position: "absolute",
        pointerEvents: 'none',
        bottom: "20px",
        right: "0px"
    }
};

const Background = styled(Box)(() => ({
    minHeight: '100vh',
    width: '100%',
    backgroundImage: `url(${backgroundImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: "1rem",
    boxSizing: 'border-box',
    position: 'relative',
}));

interface IOnboardCardLayoutProps {
    pageTitle: string;
    checkboxContent?: string;
    pageDescription?: string;
    onClickNext?: (checked: boolean) => void;
    content?: any[];
    mode?: "privacy" | "terms"
}

const OnboardCardLayout = (props: IOnboardCardLayoutProps) => {
    const { pageTitle, checkboxContent, pageDescription, content, onClickNext, mode } = props
    const { t } = useTranslation();

    return (
        <Background>
            <Box sx={styles.subContainer}>
                <Box sx={{ zIndex: 1, px: "20px" }}>
                    <CommonTermsCard
                        pageTitle={pageTitle}
                        pageDescription={pageDescription}
                        checkboxContent={checkboxContent}
                        data={content}
                        onButtonClick={onClickNext}
                        mode={mode}
                        buttonLabel={t(TranslationMessage.NEXT_BTN_LABEL)} />
                </Box>
            </Box>
            <Box sx={styles.bottomContainer}>
                <img src={lifegraphLogo} style={{ height: '50px', width: "210px" }} alt="lifegraph-onboard-logo" />
            </Box>
        </Background>
    );
}

export default OnboardCardLayout